import DiarySvg from '../icons/DiarySvg';

const menuItems = [
    { key: 1, label: 'Frukost', icon: 'mugHot' },
    { key: 3, label: 'Lunch', icon: 'bowlHot' },
    { key: 5, label: 'Middag', icon: 'plateUtensils' },
    { key: 8, label: 'Mellanmål', icon: 'apple' },
    { key: 0, label: 'Snacks / Övrigt', icon: 'strawberry' }
];

const ModalMenu = ({ activeMealType, onSelect }) => {
    return (
        <div className="modal-menu-bar">
            {menuItems.map((item) => {
                const isActive = activeMealType === item.key;

                return (
                    <div
                        key={item.key}
                        className={`menu-item ${isActive ? 'active' : ''}`}
                        onClick={() => onSelect(item.key)}
                    >
                        <span className="icon-wrapper">
                            <DiarySvg name={item.icon} color={isActive ? '#A77E52' : '#CDCDCD'} />
                        </span>

                        <span>{item.label}</span>
                    </div>
                );
            })}
        </div>
    );
};

export default ModalMenu;
